import { Table } from '@material-ui/core'
import { formatarData } from 'helpers/formatador'
import { DadosDatas } from 'models/Viabilidade/Datas'
import { TableContainerCustomizado, TableCellLabel, TableRowAlternada, TableCellValor } from '../index.style'

const CartaoDatas: React.FC<{ dados: DadosDatas }> = ({ dados }) => {
  return (
    <TableContainerCustomizado>
      <Table data-cy="tableDatas">
        <TableRowAlternada>
          <TableCellLabel>Data da Compra</TableCellLabel>
          <TableCellValor data-cy="campoCompra">{formatarData(dados.compra)}</TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Data Registro da Escritura</TableCellLabel>
          <TableCellValor data-cy="campoRegistroEscritura">{formatarData(dados.registroEscritura)}</TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Data Alvará Aprovação</TableCellLabel>
          <TableCellValor data-cy="campoAlvaraAprovacao">{formatarData(dados.alvaraAprovacao)}</TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Data Alvará Execução</TableCellLabel>
          <TableCellValor data-cy="campoAlvaraExecucao">{formatarData(dados.alvaraExecucao)}</TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Previsão do RI (data)</TableCellLabel>
          <TableCellValor data-cy="campoPrevisaoRi">{formatarData(dados.previsaoRi)}</TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Previsão de Lançamento</TableCellLabel>
          <TableCellValor data-cy="campoPrevisaoLancamento">{formatarData(dados.previsaoLancamento)}</TableCellValor>
        </TableRowAlternada>
      </Table>
    </TableContainerCustomizado>
  )
}

export default CartaoDatas
